export const loadPillarCollectStript = (token) => new Promise(resolve => {
  const source = 'https://secure.safewebservices.com/token/Collect.js';

  const existingScript = document.querySelector(`script[src="${source}"]`);
  if (existingScript) {
    existingScript.parentNode.removeChild(existingScript);
  }

  const script = document.createElement('script');
  script.src = source;
  script.setAttribute('data-tokenization-key', token);
  script.onload = () => {
    console.log('Pillar collect loaded');
    resolve();
  };
  document.head.appendChild(script);
});
